import { render, staticRenderFns } from "./AssetsAddNew.vue?vue&type=template&id=328988fd&"
import script from "./AssetsAddNew.vue?vue&type=script&lang=js&"
export * from "./AssetsAddNew.vue?vue&type=script&lang=js&"
import style0 from "./AssetsAddNew.vue?vue&type=style&index=0&id=328988fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports